import Loading from '@ifca-root/react-component/src/components/Loading/Loading';
import { Grid } from '@material-ui/core';
import { gql, useQuery } from '@apollo/client';
import { getAccessToken } from 'AccessToken';
import React from 'react';

const GET_TAX_SUMMARY = gql`
	query getTaxSummary(
		$outletID: String!
		$orderID: String!
		$accountID: String!
	) {
		getTaxSummary(
			outletID: $outletID
			orderID: $orderID
			accountID: $accountID
		)
	}
`;

const GET_PATRON_TAX_SUMMARY = gql`
	query getPatronTaxSummary($outletID: String!, $orderID: String!) {
		getPatronTaxSummary(outletID: $outletID, orderID: $orderID)
	}
`;

export const SSTSummaryComponent = props => {
	const { outletID, orderID, accountID } = props;
	const hasAuth = !!getAccessToken() && !!accountID;
	const canLoad = !!outletID && !!orderID;

	const { loading: authLoading, data: authData } = useQuery(GET_TAX_SUMMARY, {
		skip: !canLoad || !hasAuth,
		fetchPolicy: 'network-only',
		variables: {
			outletID: outletID as string,
			orderID: orderID as string,
			accountID: accountID as string,
		},
	});

	const { loading: publicLoading, data: publicData } = useQuery(
		GET_PATRON_TAX_SUMMARY,
		{
			skip: !canLoad || hasAuth,
			fetchPolicy: 'network-only',
			variables: {
				outletID: outletID as string,
				orderID: orderID as string,
			},
		},
	);

	const getTaxSummaryLoading = hasAuth ? authLoading : publicLoading;
	const getTaxSummary =
		(hasAuth ? authData?.getTaxSummary : publicData?.getPatronTaxSummary) ||
		[];

	const totalAmount = getTaxSummary?.reduce((a, b) => {
		return a + (b?.amount || 0);
	}, 0);

	const totalTaxAmount = getTaxSummary?.reduce((a, b) => {
		return a + (b?.taxAmount || 0);
	}, 0);

	if (!canLoad) {
		return null;
	}

	return (
		<>
			{getTaxSummaryLoading && <Loading />}

			<div
				className={'xsTitle'}
				style={{ fontSize: '16px', paddingTop: '5px', paddingBottom: '10px' }}
			>
				{`SST Summary`}{' '}
			</div>

			<Grid container>
				<Grid item xs={4}>
					<span
						className="xsTitle text-noflow"
						style={{ fontSize: '16px' }}
					>{`Tax Cd`}</span>
				</Grid>

				<Grid item xs={5} style={{ textAlign: 'right' }}>
					<span
						className="xsTitle text-noflow"
						style={{ fontSize: '16px' }}
					>{`Amt Excl SST(RM)`}</span>
				</Grid>

				<Grid item xs={3} style={{ textAlign: 'right' }}>
					<span
						className="xsTitle text-noflow"
						style={{ fontSize: '16px' }}
					>{`Tax(RM)`}</span>
				</Grid>
			</Grid>

			{getTaxSummary?.map((x, index) => {
				return (
					<Grid container key={`${x?.code || 'tax'}-${index}`}>
						<Grid item xs={4}>
							<span
								className="mdDesc text-noflow"
								style={{ fontSize: '16px' }}
							>
								{x?.code}
							</span>
						</Grid>

						<Grid item xs={5} style={{ textAlign: 'right' }}>
							<span
								className="mdDesc text-noflow"
								style={{ fontSize: '16px' }}
							>
								{Number(x?.amount || 0).toLocaleString('en-MY', {
									minimumFractionDigits: 2,
									maximumFractionDigits: 2,
								})}
							</span>
						</Grid>

						<Grid item xs={3} style={{ textAlign: 'right' }}>
							<span
								className="mdDesc text-noflow"
								style={{ fontSize: '16px' }}
							>
								{Number(x?.taxAmount || 0).toLocaleString('en-MY', {
									minimumFractionDigits: 2,
									maximumFractionDigits: 2,
								})}
							</span>
						</Grid>
					</Grid>
				);
			})}

			<Grid container>
				<Grid item xs={4}>
					<span
						className="xsTitle text-noflow"
						style={{ fontSize: '16px' }}
					>{`Total`}</span>
				</Grid>

				<Grid item xs={5} style={{ textAlign: 'right' }}>
					<span className="xsTitle text-noflow" style={{ fontSize: '16px' }}>
						{Number(totalAmount || 0).toLocaleString('en-MY', {
							minimumFractionDigits: 2,
							maximumFractionDigits: 2,
						})}
					</span>
				</Grid>

				<Grid item xs={3} style={{ textAlign: 'right' }}>
					<span className="xsTitle text-noflow" style={{ fontSize: '16px' }}>
						{Number(totalTaxAmount || 0).toLocaleString('en-MY', {
							minimumFractionDigits: 2,
							maximumFractionDigits: 2,
						})}
					</span>
				</Grid>
			</Grid>
		</>
	);
};
